<template>
<div class="popHeaderEdit" v-if="centerDialogVisible">
    <el-dialog :title="title+'队长'" :visible.sync="centerDialogVisible" width="720px" center>
        <el-form :model="item" :rules="rules" ref="formName" label-width="140px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="活动名称">
                <div>{{item.eventtitle}}</div>
            </el-form-item>
            <el-form-item label="设置用户">
                <div class="box">
                    <img :src="item.customericonurl" alt="" class="img">
                    <span>{{item.customername}}</span>
                </div>
            </el-form-item>
            <el-form-item label="队长收益方式">
                <span v-if="flag==1">{{item.brokeragetype==1?'固定收益':'订单比例'}}</span>
                <el-radio-group v-else v-model="item.brokeragetype" :disabled=" item.distype!=1">
                    <el-radio :label="1">固定收益</el-radio>
                    <el-radio :label="2">订单比例</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="'队长收益值（'+(item.brokeragetype==1?'元':'%')+'）'"  prop="brokerage">
                <span v-if="flag==1">{{item.brokerage}}{{item.brokeragetype==1?'元':'%'}}/订单</span>
                <el-input v-else v-model.trim="item.brokerage" placeholder="请输入队长收益值" clearable></el-input>
            </el-form-item>
            <el-form-item label="队长有效期"  prop="expiretime">
                <span v-if="flag==1">{{item.expiretime}}</span>
                <el-date-picker v-else v-model="item.expiretime" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="this.flag != 1">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="editHeader">设置完成</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {updateEventHeaderInfo, getUserInfoByEventHeader} from 'api/nationalDistribution'
import {mapActions} from 'vuex'
export default {
    name: 'popHeaderEdit',
    data() {
        let checkExpiretime = (rule, value, callback) => {
            let expiretime = new Date(this.item.expiretime) ? new Date(this.item.expiretime) : ''
            let eventendtime = new Date(this.item.eventendtime) ? new Date(this.item.eventendtime) : ''
            if (expiretime > eventendtime) {
                callback(new Error('队长有效期不能大于活动结束时间'))
            } else {
                callback()
            }
        }
        return {
            centerDialogVisible: false,
            flag: 1,
            title: '查看队长',
            item: {
                eventinnerid: '',
                disuserid: '',
                brokerage: '',
                distype: 0, // 1 支付 2 表单 3 于都
                expiretime: '',
                brokeragetype: 1,
                customericonurl: '',
                customername: ''
            },
            rules: {
                brokerage: [
                    {required: true, message: '请输入队长收益值', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的队长收益值（2位小数）', trigger: 'blur'}
                ],
                expiretime: [
                    {required: true, message: '请输入队长有效期', trigger: 'blur'},
                    {validator: checkExpiretime, trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        open(obj, flag) {
            this.flag = flag
            this.centerDialogVisible = true
            switch (this.flag) {
            case 1: this.title = '查看'
                break
            case 2: this.title = '设为'
                break
            case 3: this.title = '修改'
                break
            }
            this.item.eventinnerid = obj.eventinnerid
            this.item.disuserid = obj.innerid
            this._getView()
        },
        editHeader() {
            this.$refs.formName.validate((valid) => {
                if (valid) {
                    this.$confirm(`${this.title}队长完成后将不能修改，继续吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._editHeader()
                    }).catch(() => {})
                }
            })
        },
        _editHeader() {
            this.setLoading(true)
            updateEventHeaderInfo({
                data: {
                    eventinnerid: this.item.eventinnerid,
                    disuserid: this.item.disuserid,
                    brokerage: this.item.brokerage,
                    expiretime: this.item.expiretime,
                    brokeragetype: this.item.brokeragetype
                },
                success: data => {
                    this.setLoading(false)
                    this.centerDialogVisible = false
                    this.$emit('getList')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getUserInfoByEventHeader({
                data: {
                    eventinnerid: this.item.eventinnerid,
                    disuserid: this.item.disuserid
                },
                success: data => {
                    this.setLoading(false)
                    this.item = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.popHeaderEdit {
    .box{
        height: 50px;
        display: flex;
        align-items: center;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .el-input, .el-input--mini, .el-input--mini .el-input__inner, .el-input__inner{
        width: 400px;
    }
}
</style>
